import axios from 'axios';
import Constants from '@/constants';

class OnlineScanService {
    constructor() {

    }

    async updateOnlineScanColumn(id, column, value, type) {
        var query = '';

        if(type === 'text') {
            query = `UPDATE realestate.online_scan SET ${column}='${value}' WHERE id=${id};`;
        } else if(type === 'number' || type === 'boolean') {
            query = `UPDATE realestate.online_scan SET ${column}=${value} WHERE id=${id};`;
        }

        var url = Constants.HOST_URL + 'runUpdateQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data) {
            alert('Error while downloading record ' + id);
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }
  
    async getDetail(id) {
        console.log('onlineScanService::getDetail ', id)
        var query = 'SELECT *';
        query += 'FROM realestate.online_scan ';
        query += 'WHERE id=' + id + ';';

        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data || response.data.length != 1) {
            alert('Error while downloading record ' + this.id);
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }
  }
  
  
export default OnlineScanService;